import { setAlert } from '../alert';
import {
    API_GET_BATCH_VOLUMES,
    API_GET_BATCH_BULK_DENSITY,
    API_GET_QUENCH_TEAM_VIDEOS,
    API_GET_BIOCHAR_MASS,
    API_GET_BATCH_CARBON_CONTENT,
    // API_GET_BIOCHAR_STORED_CARBON,
    API_POST_QUENCH_TEAM_VIDEOS,
    API_POST_BATCH_CARBON_CONTENT,
    // API_POST_BIOCHAR_STORED_CARBON,
    API_GET_CB_BATCH_DATA,
    API_GET_CB_ADDITIONAL_BATCH_DATA,
    API_GET_BATCH_MEDIA,
    API_GET_CB_FIELD_NOTES,
    API_CB_IGNITION_FUEL,
    API_GET_QUENCH_TEAM_VIDEOS_DATA,
    API_POST_QUENCH_TEAM_VIDEOS_DATA
} from './constants/conservation-burn-constants';
import {
    GET_BATCH_VOLUMES_SUCCESS,
    GET_BATCH_VOLUMES_FAIL,
    GET_BATCH_BULK_DENSITY_SUCCESS,
    GET_BATCH_BULK_DENSITY_FAIL,
    GET_QUENCH_TEAM_VIDEOS_SUCCESS,
    GET_QUENCH_TEAM_VIDEOS_FAIL,
    GET_BIOCHAR_MASS_SUCCESS,
    GET_BIOCHAR_MASS_FAIL,
    GET_BATCH_CARBON_CONTENT_SUCCESS,
    GET_BATCH_CARBON_CONTENT_FAIL,
    // GET_BIOCHAR_STORED_CARBON_SUCCESS,
    // GET_BIOCHAR_STORED_CARBON_FAIL,
    POST_QUENCH_TEAM_VIDEOS_SUCCESS,
    POST_QUENCH_TEAM_VIDEOS_FAIL,
    POST_BATCH_CARBON_CONTENT_SUCCESS,
    POST_BATCH_CARBON_CONTENT_FAIL,
    // POST_BIOCHAR_STORED_CARBON_SUCCESS,
    // POST_BIOCHAR_STORED_CARBON_FAIL,
    GET_CB_BATCH_DATA_SUCCESS,
    GET_CB_BATCH_DATA_FAIL,
    GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS,
    GET_CB_ADDITIONAL_BATCH_DATA_FAIL,
    GET_BATCH_MEDIA_SUCCESS,
    GET_BATCH_MEDIA_FAIL,
    GET_CB_FIELD_NOTES_SUCCESS,
    GET_CB_FIELD_NOTES_FAIL,
    GET_CB_IGNITION_FUEL_SUCCESS,
    POST_CB_IGNITION_FUEL_SUCCESS,
    POST_CB_IGNITION_FUEL_FAIL,
    GET_CB_IGNITION_FUEL_FAIL,
    GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
    GET_QUENCH_TEAM_VIDEOS_DATA_FAIL,
    POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
    POST_QUENCH_TEAM_VIDEOS_DATA_FAIL
} from './types/conservation-burn-types';

import api from '../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json',
    }
};

const formDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
}

export const getCbBatchData = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CB_BATCH_DATA + `/${project}`,
            config
        );
        dispatch({
            type: GET_CB_BATCH_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_CB_BATCH_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBatchMedia = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BATCH_MEDIA + `/${project}`,
            config
        );
        dispatch({
            type: GET_BATCH_MEDIA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BATCH_MEDIA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getCbFieldNotes = (project, rowsPerPage, currentPage, searchQuery) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CB_FIELD_NOTES + `/${project}/${rowsPerPage}/${currentPage}`,
            {
                ...config,
                params: { search: searchQuery }
            }
        )
        dispatch({
            type: GET_CB_FIELD_NOTES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CB_FIELD_NOTES_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const postCbIgnitionFuel = (userId, projectId, rowsPerPage, currentPage, formData) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_CB_IGNITION_FUEL + `/${userId}/${projectId}/${rowsPerPage}/${currentPage}`,
            formData,
            formDataConfig
        )
        dispatch({
            type: POST_CB_IGNITION_FUEL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: POST_CB_IGNITION_FUEL_FAIL,
            payload: error.response.data.detail
        })
    }
}

export const getCbIgnitionFuel = (userId, projectId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_CB_IGNITION_FUEL + `/${userId}/${projectId}/${rowsPerPage}/${currentPage}`,
            config
        )
        dispatch({
            type: GET_CB_IGNITION_FUEL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'))
    } catch (error) {
        dispatch(setAlert(error.response.data.detail, 'error'));
        dispatch({
            type: GET_CB_IGNITION_FUEL_FAIL,
            payload: error.response.data.detail
        })
    }
}

// GET Actions
// reallocate
export const getBatchVolumes = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BATCH_VOLUMES + `/${project}`,
            config
        );
        dispatch({
            type: GET_BATCH_VOLUMES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BATCH_VOLUMES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// reallocate
export const getBatchBulkDensity = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BATCH_BULK_DENSITY + `/${project}`,
            config
        );
        dispatch({
            type: GET_BATCH_BULK_DENSITY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BATCH_BULK_DENSITY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// reallocate
export const getBiocharMass = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BIOCHAR_MASS + `/${project}`,
            config
        );
        dispatch({
            type: GET_BIOCHAR_MASS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BIOCHAR_MASS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// deprecated
export const getQuenchTeamVideos = (project, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_QUENCH_TEAM_VIDEOS + `/${project}`,
            {
                ...config,
                params: { rows_per_page: rowsPerPage, current_page: currentPage }
            }
        );
        dispatch({
            type: GET_QUENCH_TEAM_VIDEOS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_QUENCH_TEAM_VIDEOS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// POST Actions
// deprecated
export const postQuenchTeamVideos = (project, formData) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_QUENCH_TEAM_VIDEOS + `/${project}`,
            formData,
            config
        );
        dispatch({
            type: POST_QUENCH_TEAM_VIDEOS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_QUENCH_TEAM_VIDEOS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getQuenchTeamVideosData = (project, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_QUENCH_TEAM_VIDEOS_DATA + `/${project}`,
            {
                ...config,
                params: { rows_per_page: rowsPerPage, current_page: currentPage }
            }
        );
        dispatch({
            type: GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_QUENCH_TEAM_VIDEOS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const postQuenchTeamVideosData = (project, formData) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_QUENCH_TEAM_VIDEOS_DATA + `/${project}`,
            formData,
            config
        );
        dispatch({
            type: POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_QUENCH_TEAM_VIDEOS_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
}

// deprecated
export const getBatchCarbonContent = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_BATCH_CARBON_CONTENT + `/${project}`,
            config
        );
        dispatch({
            type: GET_BATCH_CARBON_CONTENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_BATCH_CARBON_CONTENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// deprecated
// export const getBiocharStoredCarbon = (project) => async dispatch => {
//     try {
//         const { data } = await axios.get(
//             process.env.REACT_APP_API_URL + API_GET_BIOCHAR_STORED_CARBON + `/${project}`,
//             config
//         );
//         dispatch({
//             type: GET_BIOCHAR_STORED_CARBON_SUCCESS,
//             payload: data,
//         });
//         dispatch(setAlert(data.detail, 'success'));
//     } catch (err) {
//         dispatch(setAlert(err.response.data.detail, 'error'));
//         dispatch({
//             type: GET_BIOCHAR_STORED_CARBON_FAIL,
//             payload: err.response.data.detail,
//         });
//     }
// };

// deprecated
export const getCbAdditionalBatchData = (project) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_CB_ADDITIONAL_BATCH_DATA + `/${project}`,
            config
        );
        dispatch({
            type: GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_CB_ADDITIONAL_BATCH_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};



// deprecated
export const postBatchCarbonContent = (project, formData) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_BATCH_CARBON_CONTENT + `/${project}`,
            formData,
            config
        );
        dispatch({
            type: POST_BATCH_CARBON_CONTENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_BATCH_CARBON_CONTENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

// deprecated
// export const postBiocharStoredCarbon = (formData) => async dispatch => {
//     try {
//         const { data } = await axios.post(
//             process.env.REACT_APP_API_URL + API_POST_BIOCHAR_STORED_CARBON,
//             formData,
//             config
//         );
//         dispatch({
//             type: POST_BIOCHAR_STORED_CARBON_SUCCESS,
//             payload: data,
//         });
//         dispatch(setAlert(data.detail, 'success'));
//     } catch (err) {
//         dispatch(setAlert(err.response.data.detail, 'error'));
//         dispatch({
//             type: POST_BIOCHAR_STORED_CARBON_FAIL,
//             payload: err.response.data.detail,
//         });
//     }
// };
